import { SearchResultsSort, SortValues } from "../../types/context";

interface SortKeys {
    [key: string]: {
        field: string;
        direction: SortValues;
    };
}

const sortKeys: SortKeys = {
    title: {
        field: "title",
        direction: "ascending",
    },
    dtitle: {
        field: "title",
        direction: "descending",
    },
};

export const composeFunnelbackSortParam = (
    sort: SearchResultsSort
): string | null => {
    const { field, direction } = sort;

    if (!sort || !field || direction === "none") {
        return null;
    }

    const matchingSortKey = Object.keys(sortKeys).find((sortKey) => {
        const sortKeyConfig = sortKeys[sortKey];
        return (
            sortKeyConfig.field === field &&
            sortKeyConfig.direction === direction
        );
    });

    if (matchingSortKey) {
        return matchingSortKey;
    }

    const metadataDirection = direction === "descending" ? "d" : "";
    return `${metadataDirection}meta${field}`;
};

const formatSortOrder = (rawSortValue: string): SearchResultsSort => {
    const sortOrder: SearchResultsSort = {
        field: "",
        direction: "none",
    };

    if (!rawSortValue) {
        return sortOrder;
    }

    // Sort on Funnelback metadata field
    const metadataPattern = new RegExp("^d?meta([a-zA-Z0-9]+)$");
    if (rawSortValue.match(metadataPattern)) {
        const metadataField = rawSortValue.replace(metadataPattern, "$1");
        if (rawSortValue.slice(0, 1) === "d") {
            sortOrder.direction = "descending";
        } else {
            sortOrder.direction = "ascending";
        }
        sortOrder.field = metadataField;
        return sortOrder;
    }

    // Built-in Funnelback sort keys
    if (rawSortValue in sortKeys) {
        return sortKeys[rawSortValue];
    }

    // Emergency fallback:
    // Should never get here
    return sortOrder;
};

export default formatSortOrder;
